import { render, staticRenderFns } from "./ManageGrowModule.vue?vue&type=template&id=f1372798"
import script from "./ManageGrowModule.vue?vue&type=script&lang=ts"
export * from "./ManageGrowModule.vue?vue&type=script&lang=ts"
import style0 from "./ManageGrowModule.vue?vue&type=style&index=0&id=f1372798&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports